export default "__VITE_ASSET__iGR6gEhX__"